import { SwitchLabel, SwitchInput, Slider, SwitchWrapper, StateLabel } from './Switch.styles'

export default function Switch({
  checked,
  onChange,
  onLabel,
  offLabel,
  ariaLabel,
  disabled = false,
  id,
}) {
  return (
    <SwitchWrapper>
      <SwitchLabel>
        <SwitchInput
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label={ariaLabel}
        />
        <Slider />
      </SwitchLabel>
      {onLabel && offLabel && (
        <StateLabel>{checked ? onLabel : offLabel}</StateLabel>
      )}
    </SwitchWrapper>
  )
}
